module.exports = __webpack_public_path__ + "img/propertysystem1.d3de3f26.png";